import * as yup from 'yup';

export const loginEmailSchema = yup.object().shape({
  email: yup.string().required().email(),
});
